import { getUserPeriodicReportListApi } from 'api/meeting';
import PeriodicReportDataTable from 'app/components/DataTable/periodic/PeriodicReportDataTable';
import LoadingPopUp from 'app/components/LoadingPopup';
import React, { useEffect, useState } from 'react';

const UploadPeriodicReportPage = () => {

    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        const getAPI = async () => {

            let list = await getUserPeriodicReportListApi();
            setData(list.data);
            setLoading(false);
        }
        getAPI()
    }, [])


    const columnData = [
        { id: 'inst', align: 'left', disablePadding: false, label: "Kurum" },
        { id: 'unitName', align: 'left', disablePadding: true, label: "Kurul/Kol/Komisyon Adı" },
        { id: 'userId', align: 'left', disablePadding: true, label: "Raporu Yükleyen" },
        { id: 'year', align: 'left', disablePadding: true, label: "Yıl" },
        { id: 'period1', align: 'left', disablePadding: false, label: "1. Dönem" },
        { id: 'period2', align: 'left', disablePadding: false, label: "2. Dönem" },
        { id: 'islemler', align: 'center', disablePadding: false, label: "Rapor Yükle" },

    ];

    return (
        <React.Fragment>
            <>
                <LoadingPopUp open={loading} />
                {!loading && <PeriodicReportDataTable mainData={data} column={columnData} pageTitle="Kurul/Kol/Komisyon Dönemlik Rapor Listesi" />}
            </>

        </React.Fragment>
    );
};

export default UploadPeriodicReportPage;